import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Index from '@/components/Index'
import Manager from '@/components/Manager/Manager'
import Parser from '@/components/Parser/Parser'
import ParserDetail from '@/components/Parser/ParserDetail'
import ParserChildrenDetail from '@/components/Parser/ParserChildrenDetail'
import Product from '@/components/Product/Product'
import Classification from '@/components/Product/Classification'
import ProductDetail from '@/components/Product/ProductDetail'
import Customer from '@/components/Customer/Customer'
import CustomerDetail from '@/components/Customer/CustomerDetail'
import CustomerC from '@/components/Customer/CustomerC'
import Equipment from '@/components/Customer/Equipment'
import Gateway from '@/components/Customer/Gateway'
import List from '@/components/Customer/List'
import LargeScreen from '@/components/Customer/LargeScreen'
import LargeScreenDetail from '@/components/Customer/LargeScreenDetail'
import DictionaryManage from '@/components/DictionaryManage/DictionaryManage'
import DictionaryClassify from '@/components/DictionaryManage/DictionaryClassify'
Vue.use(Router)

const router = new Router({
	base: './', // 加上这一行 服务器的配置
	//	base: '/zkepA2/', // 加上这一行 服务器的配置
	//base: '/zkepA/', // 加上这一行 服务器的配置
	routes: [{
			path: '/',
			redirect: '/login',
		}, {
			path: '/login', //登陆
			name: 'Login',
			component: Login
		},
		{
			path: '/home',
			name: 'Home',
			component: Home,
			redirect: '/manager/manager',
			children: [{
					path: '/index', //首页
					name: 'Index',
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
					component: Index
				},
				{
					path: '/manager/manager', //用户管理
					name: 'Manager',
					meta: {
						requireAuth: true
					},
					component: Manager
				},
				{
					path: '/parser/parser', //抄读管理
					name: 'Parser',
					meta: {
						requireAuth: true
					},
					component: Parser
				},
				{
					path: '/parser/parserDetail', //抄读详细
					name: 'ParserDetail',
					meta: {
						requireAuth: true
					},
					component: ParserDetail
				},
				{
					path: '/parser/parserChildrenDetail', //抄读项详细
					name: 'ParserChildrenDetail',
					meta: {
						requireAuth: true
					},
					component: ParserChildrenDetail
				},
				{
					path: '/product/product', //产品管理
					name: 'Product',
					meta: {
						requireAuth: true
					},
					component: Product
				},
				{
					path: '/product/classification', //产品分类
					name: 'Classification',
					meta: {
						requireAuth: true
					},
					component: Classification
				},
				{
					path: '/product/productDetail', //产品详细
					name: 'ProductDetail',
					meta: {
						requireAuth: true
					},
					component: ProductDetail
				},
				{
					path: '/customer/customer', //客户管理
					name: 'Customer',
					meta: {
						requireAuth: true
					},
					component: Customer
				},
				{
					path: '/customer/customerDetail', //客户详细
					name: 'CustomerDetail',
					meta: {
						requireAuth: true
					},
					component: CustomerDetail
				}, {
					path: '/customer/largeScreen', //大屏幕
					name: 'LargeScreen',
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
					component: LargeScreen
				}, {
					path: '/customer/largeScreenDetail', //大屏幕详细
					name: 'LargeScreenDetail',
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
					component: LargeScreenDetail
				}, {
					path: '/dictionaryManage/dictionaryManage', //字典管理
					name: 'DictionaryManage',
					meta: {
						requireAuth: true
					},
					component: DictionaryManage
				}, {
					path: '/dictionaryManage/dictionaryClassify', //字典分类
					name: 'DictionaryClassify',
					meta: {
						requireAuth: true
					},
					component: DictionaryClassify
				},
				{
					path: '/customer/customerC', //C端客户(主)
					name: 'CustomerC',
					meta: {
						requireAuth: true
					},
					component: CustomerC,
					children: [{
							path: '/customer/equipment', //设备
							name: 'Equipment',
							meta: {
								requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
							},
							component: Equipment
						}, {
							path: '/customer/gateway', //网关
							name: 'Gateway',
							meta: {
								requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
							},
							component: Gateway
						}, {
							path: '/customer/list', //子组件
							name: 'List',
							meta: {
								requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
							},
							component: List
						},

					]
				}

			]
		},
	]
})
export default router
router.beforeEach((to, from, next) => {
	if(to.meta.requireAuth) { // 判断该路由是否需要登录权限
		var id = window.sessionStorage.getItem('id')
		//		console.log(id)
		if(id) { // 通过vuex state获取当前的token是否存在
			window.sessionStorage.setItem('referrer', '') //储存来源路由
			//			console.log('111111')
			next();
		} else {
			window.sessionStorage.setItem('referrer', to.fullPath) //储存来源路由
			//			console.log('拦截到登录')
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				} // 将跳转的路由path作为参数，登录成功后跳转到该路由
			})
		}
	} else {
		//		console.log('222222')
		next();
	}
})
//相同路由重复点击报错的处理
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js